import React, { useState } from "react";
import { Grid, Box, useMediaQuery, Typography, Paper } from "@mui/material";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";

// Import Original Components
import Welcome from "./Welcome";
import Shipping from "./Shipping";
import DeferralCom from "./DeferralCom";
import Quarantine from "./Quarantine";
import Orphan from "./Orphan";
import LobbyCom from "./LobbyCom";
import PhlebotomyCom from "./PhlebotomyCom";
import PhysicalCom from "./PhysicalCom";
import RegistrationCom from "./RegistrationCom";
import AlertCom from "./AlertsCom";
import SupplyAlertCom from "./SupplyAlertCom";
import CollectionCom from "./CollectionCom";
import Dummy from "./Dummy";

// Import Your New Chart Components
import BasicColumn from "./BasicColumn";
import BasicColumnPay from "./BasicColumnPay";
import PieChartWithCenterLabel from "./Piechart";

const Dashboard = () => {
    const [state] = useState({});
    const { shipping, quarantine, orphan } = state;

    const user = localStorage.token ? jwt_decode(localStorage.token) : {};
    const userLevel = user?.level || 0;
    const userCode = user?.code || "";

    if (userLevel === 1) {
        return <Redirect to="/custom" />;
    }

    // Custom wrapper to maintain consistent spacing and styling for charts
    const ChartCard = ({ title, children }) => (
        <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold', alignSelf: 'flex-start' }}>
                {title}
            </Typography>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                {children}
            </Box>
        </Paper>
    );

    return (
        <Box sx={{ flexGrow: 1, p: 0.5 }}>
            <Grid container spacing={1} alignItems="stretch">
                
                {/* Analytics Row - New Section */}
                {userLevel > 6 && (
                    <>
                        <Grid item xs={12} md={4}>
                            <Paper sx={{ p: 2, height: '100%' }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>Volume</Typography>
                                <BasicColumn height={250} />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Paper sx={{ p: 2, height: '100%' }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>Payments</Typography>
                                <BasicColumnPay height={250} />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Paper sx={{ p: 2, height: '100%' }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>Inventory</Typography>
                                <PieChartWithCenterLabel height={250} width={350} />
                            </Paper>
                        </Grid>
                    </>
                )}

                {/* Original Alerts Row */}
                {userLevel > 6 && userLevel !== 1.5 && userLevel !== 99 && (
                    <>
                        <Grid item xs={12} sm={6} md={4}>
                            <Orphan value={orphan} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Quarantine value={quarantine} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Shipping value={shipping} />
                        </Grid>
                        <Grid item xs={12}>
                            <AlertCom />
                        </Grid>
                        <Grid item xs={12}>
                            <SupplyAlertCom />
                        </Grid>
                    </>
                )}

                {/* Operational Components */}
                <Grid item xs={12} sm={6} md={4}>
                    {userLevel !== 3 &&
                        userLevel !== 4 &&
                        !["PHYS", "PHYN", "PLAP", "QA"].includes(userCode) &&
                        userLevel !== 1.5 &&
                        userLevel !== 99 && <DeferralCom />}
                </Grid>

                <Dummy />
                
                <Grid item xs={12} sm={6} md={4}>
                    {userLevel !== 4 &&
                        userLevel !== 1.5 &&
                        userLevel !== 99 &&
                        !["PLAP", "QA"].includes(userCode) && <RegistrationCom />}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    {userLevel !== 4 &&
                        userLevel !== 1.5 &&
                        userLevel !== 99 &&
                        !["PLAP", "QA"].includes(userCode) && <LobbyCom />}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    {["PHYS", "PHYN"].includes(userCode) || userLevel > 6 ? (
                        <PhysicalCom />
                    ) : null}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    {userLevel !== 2 &&
                        userLevel !== 1.5 &&
                        userLevel !== 99 &&
                        !["PLAP", "QA"].includes(userCode) && <PhlebotomyCom />}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    {userLevel > 5 &&
                        userLevel !== 1.5 &&
                        userLevel !== 99 &&
                        userCode !== "QA" && <CollectionCom />}
                </Grid>

                <Grid item xs={12}>
                    <Welcome />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;

